import * as React from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import {Box, Stack} from '@mui/system';
import {
  getLMSResultsData,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {enqueueSnackbar} from 'src/minimal-components/snackbar';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useAppContext} from '@context/AppContext';
import {BASE_RECORD_ID} from 'src/routes/BaseRoute';
import {LoadingButton} from '@mui/lab';
import SelectInput from '@components/form/select-input/SelectInput';
import {
  FormControlLabel,
  MenuItem,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
interface UiFields {
  module_sql: {
    sql_data: any;
    [key: string]: any;
  };
  [key: string]: any;
}
type UserItem = {id: string; full_name: string};
interface AssignMembersProps {
  uiFieldsData: any;
}
function not(a: UserItem[], b: UserItem[]) {
  const bIds = b.map(x => x.id);
  return a.filter(x => !bIds.includes(x.id));
}

function intersection(a: UserItem[], b: UserItem[]) {
  return a.filter(x => b.some(item => item.id === x.id));
}

function union(a: UserItem[], b: UserItem[]) {
  return [...a, ...not(b, a)];
}

const AssignMembers = ({
  uiFieldsData
}: AssignMembersProps): React.ReactElement => {
  const {
    appState: {applicationName, hospitalId}
  } = useAppContext();
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const dropDownData = [
    {external_org_id: 1, external_org_name: 'By User'},
    {external_org_id: 2, external_org_name: 'By Role'}
  ];
  const [left, setLeft] = React.useState<UserItem[]>([]);
  const [right, setRight] = React.useState<UserItem[]>([]);
  const [checked, setChecked] = React.useState<UserItem[]>([]);
  const [loader, setLoader] = React.useState(false);
  const [uiFields, setUiFields] = React.useState<UiFields | undefined>(
    uiFieldsData?.searchForm
  );
  const [users, setUsers] = React.useState();
  const [assignMembers, setAssignMembersloader] = React.useState(false);
  const [saved, setSaved] = React.useState(false);
  const leftChecked = intersection(left, checked);
  const rightChecked = intersection(right, checked);
  const [status, setStatus] = React.useState('');
  const [initialloader, setLoaderInitial] = React.useState(false);
  const [searchTextRight, setSearchTextRight] = React.useState('');
  const [searchTextLeft, setSearchTextLeft] = React.useState('');
  const [dropDownRoleData, setDropDownRoleData]: any = React.useState<
    {id: number; name: string}[]
  >([]);
  const [roleType, setRoleType] = React.useState();
  const [type, setType] = React.useState(1);
  const fetchData = async () => {
    try {
      setLoader(true);
      let res = uiFieldsData;
      if (uiFieldsData === null || uiFieldsData === undefined) {
        res = await getSearchForm(applicationName, 'Member');
        await setUiFields(res.searchForm);
      } else {
        setUiFields(uiFieldsData.searchForm);
      }
      if ((res?.searchForm && uniqueId) || uiFieldsData) {
        const {sql_data} =
          uiFieldsData.searchForm['module_sql'] || res.searchForm['module_sql'];
        let operations;
        if (uniqueId) {
          operations = 'SEARCH';
        }
        const data: any = {
          sql_data: sql_data,
          data: {course_overview_id: uniqueId},
          operation: operations
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        if (result.data) {
          setUsers(result.data);
          setLeft(result.data[0].Unassigned_Users || []);
          setRight(result.data[0].Assigned_Users || []);
          setStatus(result.data[0].CourseStatus || '');
        }
        setLoader(false);
      }

      setLoader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };
  const InitialfetchData = async () => {
    try {
      setLoaderInitial(true);
      let res = uiFieldsData;
      if (uiFieldsData === null || uiFieldsData === undefined) {
        res = await getSearchForm(applicationName, 'Member');
        await setUiFields(res.searchForm);
      } else {
        setUiFields(uiFieldsData?.searchForm);
      }
      if ((res?.searchForm && uniqueId) || uiFieldsData) {
        const {sql_data} =
          uiFieldsData?.searchForm['module_sql'] ||
          res.searchForm['module_sql'];

        let operations;
        if (uniqueId) {
          operations = 'SEARCH';
        }
        const data: any = {
          sql_data: sql_data,
          data: {course_overview_id: uniqueId},
          operation: operations
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        if (result.data) {
          setUsers(result.data);
          setLeft(result.data[0].Unassigned_Users || []);
          setRight(result.data[0].Assigned_Users || []);
          setStatus(result.data[0].CourseStatus || '');
        }
        setLoader(false);
      }

      setLoaderInitial(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoaderInitial(false);
    }
  };
  const fetchRoleData = async () => {
    try {
      setLoader(true);
      let res;
      if (uiFieldsData === null || uiFieldsData === undefined) {
        res = await getSearchForm(applicationName, 'Member');
        await setUiFields(res.searchForm);
      } else {
        setUiFields(uiFieldsData?.searchForm);
      }
      if ((res?.searchForm && uniqueId) || uiFieldsData) {
        const {sql_data} =
          uiFieldsData?.searchForm['module_sql'] ||
          res.searchForm['module_sql'];

        let operations;
        if (uniqueId) {
          operations = 'FetchAssignedRolesUsers';
        }
        const data: any = {
          sql_data: sql_data,
          data: {
            course_overview_id: uniqueId,
            RoleId: roleType,
            schema: 'App_minimal',
            orgid: hospitalId
          },
          operation: operations
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        if (result.data) {
          setUsers(result.data);
          setLeft(result.data[0].Unassigned_Users || []);
          setRight(result.data[0].Assigned_Users || []);
          // const assignedUsers = result.data[0]?.Assigned_Users || [];
          // const unassignedUsers = result.data[0]?.Unassigned_Users || [];
          // setRight(prev => {
          //   const existingIds = new Set(prev.map(user => user.id));
          //   const newUsers = assignedUsers.filter(
          //     (user: {id: string}) => !existingIds.has(user.id)
          //   );
          //   return [...prev, ...newUsers];
          // });

          // // Update left: exclude users already in assignedUsers
          // const assignedIds = new Set(
          //   assignedUsers.map((user: {id: any}) => user.id)
          // );
          // const filteredLeft = unassignedUsers.filter(
          //   (user: {id: unknown}) => !assignedIds.has(user.id)
          // );
          // setLeft(filteredLeft);

          setStatus(result.data[0].CourseStatus || '');
        }
        setLoader(false);
      }

      setLoader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };
  React.useEffect(() => {
    InitialfetchData();
  }, []);
  React.useEffect(() => {
    if (type === 1) {
      fetchData();
    }
    if (type === 2) {
      setRoleType(undefined);
    }
  }, [type]);
  React.useEffect(() => {
    if (roleType) {
      fetchRoleData();
    }
  }, [roleType]);
  const handleLegacyAppChange = async (event: any, name: string) => {
    if (uiFields && uiFields?.module_sql) {
      try {
        const data: any = {
          sql_data: uiFields?.module_sql.sql_data,
          sort: uiFields?.module_sql.sql_data.order_by,
          sort_by: uiFields?.module_sql.sql_data.sort_by,
          data: {schema: 'App_minimal', orgid: hospitalId},
          operation: 'FetchRoles'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        setDropDownRoleData(result.data);
        // const new_options = generateOptionsList(
        //   [{generate_options: true}],
        //   result?.data
        // );
        // await setDropDownData((prevData: any[]) => {
        //   const existingEntry = prevData?.find(
        //     (entry: {Name: string}) => entry.Name === name
        //   );

        //   if (existingEntry) {
        //     // If the Name already exists, update its Values
        //     return [...prevData];
        //   }

        //   // If the Name is new, add it to the array
        //   return [...prevData, {Name: name, Values: new_options}];
        // });
        // return new_options;
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    } else {
      const res = await getSearchForm(applicationName, 'FetchHospitalId');
      setDropDownRoleData(res?.searchForm);
      try {
        const data: any = {
          sql_data: res?.searchForm?.module_sql.sql_data,
          sort: res?.searchForm?.module_sql.sql_data.order_by,
          sort_by: res?.searchForm?.module_sql.sql_data.sort_by,
          data: {schema: 'App_minimal', orgid: hospitalId},
          operation: 'FetchRoles'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        setDropDownRoleData(result.data);
        // const new_options = generateOptionsList(
        //   [{generate_options: true}],
        //   result?.data
        // );
        // await setDropDownData((prevData: any[]) => {
        //   const existingEntry = prevData?.find(
        //     (entry: {Name: string}) => entry.Name === name
        //   );

        //   if (existingEntry) {
        //     // If the Name already exists, update its Values
        //     return [...prevData];
        //   }

        //   // If the Name is new, add it to the array
        //   return [...prevData, {Name: name, Values: new_options}];
        // });
        // return new_options;
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    }
  };
  const handleAssignMembers = async () => {
    try {
      setAssignMembersloader(true);
      if (uiFields) {
        const {sql_data} = uiFields['module_sql'];
        let operations;
        if (uniqueId) {
          operations = 'INSERT';
        }
        if (roleType && type === 2) {
          const data = {
            sql_data: sql_data,
            data: {
              RoleId: roleType,
              schema: 'App_minimal',
              course_overview_id: uniqueId,
              assignedId: JSON.stringify(right.map((item: UserItem) => item.id))
            },
            operation: operations
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const res = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          if (res.success) {
            enqueueSnackbar(
              'Members assigned successfully',
              SnackBarConfig.getSuccess()
            );
          }
        } else {
          const data = {
            sql_data: sql_data,
            data: {
              course_overview_id: uniqueId,
              assignedId: JSON.stringify(right.map((item: UserItem) => item.id))
            },
            operation: operations
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const res = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          if (res.success) {
            enqueueSnackbar(
              'Members assigned successfully',
              SnackBarConfig.getSuccess()
            );
          }
        }
        setAssignMembersloader(false);
        enqueueSnackbar(
          'Members assigned successfully',
          SnackBarConfig.getSuccess()
        );
      }
      setAssignMembersloader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setAssignMembersloader(false);
    }
  };

  const handleToggle = (value: UserItem) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items: UserItem[]) =>
    intersection(checked, items).length;

  const handleToggleAll = (items: UserItem[]) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setSaved(true);
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setSaved(true);
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };
  const customListLeft = (title: React.ReactNode, items: UserItem[]) => {
    // Filtered items based on search text
    let filteredItems;
    if (title === 'UnAssigned' && searchTextLeft.trim().length > 0) {
      filteredItems = items.filter(
        item =>
          item.full_name !== undefined &&
          item.full_name !== null &&
          item.full_name.trim().length > 0 &&
          item.full_name.toLowerCase().includes(searchTextLeft.toLowerCase())
      );
    } else {
      filteredItems = items;
    }

    return (
      <Card
        sx={{
          width: '100%',
          height: '100%',
          p: 1,
          boxShadow: '2px -1px 2px 2px rgb(182 185 181 / 28%)'
        }}>
        <CardHeader
          avatar={
            <Checkbox
              onClick={handleToggleAll(filteredItems)}
              checked={
                numberOfChecked(filteredItems) === filteredItems.length &&
                filteredItems.length !== 0
              }
              indeterminate={
                numberOfChecked(filteredItems) !== filteredItems.length &&
                numberOfChecked(filteredItems) !== 0
              }
              disabled={filteredItems.length === 0}
              inputProps={{
                'aria-label': 'all items selected'
              }}
            />
          }
          title={title}
          subheader={`${numberOfChecked(filteredItems)}/${filteredItems.length} selected`}
        />

        <Divider />

        {/* Search Input */}
        <Box sx={{px: 2, pt: 1}}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by name..."
            value={searchTextLeft}
            onChange={e => setSearchTextLeft(e.target.value)}
          />
        </Box>

        <List
          sx={{
            bgcolor: 'lightgrey',
            overflow: 'auto',
            maxHeight: '29vw',
            mt: 1
          }}
          dense
          component="div"
          role="list">
          {filteredItems.map((item: UserItem) => {
            const labelId = `transfer-list-item-${item.id}-label`;
            return (
              <ListItemButton
                key={item.id}
                role="listitem"
                onClick={handleToggle(item)}>
                <ListItemIcon>
                  <Checkbox
                    checked={checked.includes(item)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{'aria-labelledby': labelId}}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={item.full_name} />
              </ListItemButton>
            );
          })}
        </List>
      </Card>
    );
  };
  const customListRight = (title: React.ReactNode, items: UserItem[]) => {
    // Filtered items based on search text
    let filteredItems;
    if (title === 'UnAssigned' && searchTextRight.trim().length > 0) {
      filteredItems = items.filter(
        item =>
          item.full_name !== undefined &&
          item.full_name !== null &&
          item.full_name.trim().length > 0 &&
          item.full_name.toLowerCase().includes(searchTextRight.toLowerCase())
      );
    } else {
      filteredItems = items;
    }

    return (
      <Card
        sx={{
          width: '100%',
          height: '100%',
          p: 1,
          boxShadow: '2px -1px 2px 2px rgb(182 185 181 / 28%)'
        }}>
        <CardHeader
          avatar={
            <Checkbox
              onClick={handleToggleAll(filteredItems)}
              checked={
                numberOfChecked(filteredItems) === filteredItems.length &&
                filteredItems.length !== 0
              }
              indeterminate={
                numberOfChecked(filteredItems) !== filteredItems.length &&
                numberOfChecked(filteredItems) !== 0
              }
              disabled={filteredItems.length === 0}
              inputProps={{
                'aria-label': 'all items selected'
              }}
            />
          }
          title={title}
          subheader={`${numberOfChecked(filteredItems)}/${filteredItems.length} selected`}
        />

        <Divider />

        {/* Search Input */}
        <Box sx={{px: 2, pt: 1}}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by name..."
            value={searchTextRight}
            onChange={e => setSearchTextRight(e.target.value)}
          />
        </Box>

        <List
          sx={{
            bgcolor: 'lightgrey',
            overflow: 'auto',
            maxHeight: '29vw',
            mt: 1
          }}
          dense
          component="div"
          role="list">
          {filteredItems.map((item: UserItem) => {
            const labelId = `transfer-list-item-${item.id}-label`;
            return (
              <ListItemButton
                key={item.id}
                role="listitem"
                onClick={handleToggle(item)}>
                <ListItemIcon>
                  <Checkbox
                    checked={checked.includes(item)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{'aria-labelledby': labelId}}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={item.full_name} />
              </ListItemButton>
            );
          })}
        </List>
      </Card>
    );
  };

  const handlepublish = async () => {
    if (status === 'PUBLISHED') {
      setStatus('DRAFTED');
    } else {
      try {
        if (uiFields && uniqueId) {
          setLoader(true);
          const {sql_data} = uiFields['module_sql'];
          let operations;
          if (uniqueId) {
            operations = 'UPDATE';
          }
          const data: any = {
            sql_data: sql_data,
            data: {course_overview_id: uniqueId, CourseStatus: 'PUBLISHED'},
            operation: operations
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          if (result.data) {
            setUsers(result.data);
            setLeft(result.data[0].Unassigned_Users || []);
            setRight(result.data[0].Assigned_Users || []);
            setStatus(result.data[0].CourseStatus || '');
          }
          setStatus('PUBLISHED');
          setLoader(false);
        }
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
        setLoader(false);
      }
    }
  };
  return initialloader ? (
    <Stack
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={'50vh'}>
      <LoadingScreen />
    </Stack>
  ) : status === 'PUBLISHED' ? (
    <Box
      sx={{
        bgcolor: 'background.paper',
        height: '100%',
        minHeight: '50vh'
      }}>
      <Box sx={{display: 'flex'}}>
        <Box sx={{ml: 2, mt: 2, mb: 2}}>
          <SelectInput
            enableDefaultOption
            name="Select Type"
            placeholder="select type"
            options={dropDownData}
            value={type}
            // onOpenCallback={(event: any) =>
            //   handleLegacyAppChange(event, 'selectorganization')
            // }
            onChange={(event: any) => {
              // setHospitalId(event);
              setType(event.target.value);
              // setState(prevState => ({
              //   ...prevState,
              //   formError: ''
              // }));
            }}
            optionValueKey={'external_org_id'}
            optionLabelKey={'external_org_name'}
            fetchOptionsFromOnOpenTrigger
            sx={{minWidth: 200}}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: '30vh', // Set dropdown max height
                  overflowY: 'auto' // Enable scrolling
                }
              }
            }}
          />
        </Box>
        {type === 2 && (
          <Box sx={{ml: 2, mt: 2}}>
            <SelectInput
              enableDefaultOption
              name="Select Role"
              placeholder="select Role"
              options={dropDownRoleData}
              value={roleType}
              onOpenCallback={(event: any) =>
                handleLegacyAppChange(event, 'selectorganization')
              }
              onChange={(event: any) => {
                // setHospitalId(event);
                setRoleType(event.target.value);
                // setState(prevState => ({
                //   ...prevState,
                //   formError: ''
                // }));
              }}
              optionValueKey={'id'}
              optionLabelKey={'name'}
              fetchOptionsFromOnOpenTrigger
              sx={{minWidth: 200}}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: '30vh', // Set dropdown max height
                    overflowY: 'auto' // Enable scrolling
                  }
                }
              }}
            />
          </Box>
        )}
      </Box>
      {loader ? (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'50vh'}>
          <LoadingScreen />
        </Stack>
      ) : (
        <>
          <Grid
            container
            spacing={2}
            p={1}
            sx={{
              display: 'flex',
              flex: 1,
              width: '100%'
            }}>
            <Grid item xs={10} sm={5} md={5.5}>
              <Box>{customListLeft('UnAssigned', left)}</Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={1}
              sx={{display: 'flex', alignItems: 'center'}}>
              <Grid container direction="column" sx={{alignItems: 'center'}}>
                <Button
                  sx={{my: 0.5}}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedRight}
                  disabled={leftChecked.length === 0}
                  aria-label="move selected right">
                  &gt;
                </Button>
                <Button
                  sx={{my: 0.5}}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedLeft}
                  disabled={rightChecked.length === 0}
                  aria-label="move selected left">
                  &lt;
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={10} sm={5} md={5.5}>
              {customListRight('Assigned', right)}
            </Grid>
          </Grid>
          <Box>
            <Box sx={{m: 2, display: 'flex', justifyContent: 'flex-end'}}>
              <LoadingButton
                loading={assignMembers}
                disabled={!saved}
                onClick={handleAssignMembers}
                variant="contained"
                color="primary">
                Save
              </LoadingButton>
            </Box>
          </Box>
        </>
      )}
    </Box>
  ) : (
    <Stack
      display={'flex'}
      justifyContent={'center'}
      sx={{backgroundColor: 'background.paper'}}
      alignItems={'center'}
      minHeight={'50vh'}>
      <Typography>
        To Assign Members Please Change the Course Status to PUBLISHED.
      </Typography>
      <Grid xs={12} md={8}>
        <FormControlLabel
          control={
            <Switch
              checked={status === 'PUBLISHED'}
              value={status}
              disabled={status === 'PUBLISHED'}
              defaultChecked={false}
              onClick={handlepublish}
            />
          }
          label="Publish"
          sx={{flexGrow: 1, pl: 3}}
        />
      </Grid>
    </Stack>
  );
};
export default AssignMembers;
